// Marquee.js — Faixa contínua e infinita, usada para desfilar capas.
// Equivalente ao `LogoLoop` do react-bits, com uma diferença importante:
// o loop é CSS puro (translate de -50 %), sem JS por frame. Numa faixa que
// nunca para, cada frame calculado em JS custa bateria a página inteira.
//
// Como o loop infinito funciona: a lista é renderizada DUAS vezes lado a lado
// e a faixa desliza exatamente metade da própria largura. Quando a animação
// reinicia, a segunda cópia está no lugar da primeira — o corte é invisível.
//
// A animação `marquee` e a pausa por prefers-reduced-motion estão em App.css.
import React from "react";

const Marquee = ({
  children,
  velocidade = 46,       // segundos para percorrer o ciclo inteiro
  direcao = "esquerda",
  className = "",
  pausarNoHover = true,
}) => {
  const itens = React.Children.toArray(children);

  return (
    <div
      className={
        "relative overflow-hidden " +
        (pausarNoHover ? "marquee-pausavel " : "") +
        className
      }
      // Máscara nas bordas: a faixa nasce e morre em fade, em vez de ser
      // cortada a seco pela lateral do contêiner.
      style={{
        maskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)",
        WebkitMaskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)",
      }}
    >
      <div
        className="marquee-faixa flex w-max"
        style={{
          animationDuration: `${velocidade}s`,
          animationDirection: direcao === "direita" ? "reverse" : "normal",
        }}
      >
        {/* Cópia 1 (a que se vê) + Cópia 2 (a que emenda o ciclo) */}
        {[0, 1].map((copia) => (
          <div key={copia} className="flex shrink-0" aria-hidden={copia === 1}>
            {itens.map((item, i) => (
              <div key={i} className="shrink-0">{item}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
